/* assets/plate-preview.js — 3D number plate live preview (Three.js r137 globals) */
(function () {
  var W = 4.685, H = 1, D = 0.06, R = 0.08; // UK plate 520x111mm ratio

  // Plate font, loaded explicitly via FontFace (canvas is unreliable with CSS @font-face).
  var FONT_URL = "https://cdn.shopify.com/s/files/1/0911/6712/9940/files/CharlesWright.woff2";
  // Optional: faded logo on the back. Leave "" to use a faded "AJ PLATES" wordmark instead.
  // Set to a Shopify Files URL of your logo (PNG with transparency works best).
  var LOGO_URL = "";

  function initPlate(root) {
    if (root.dataset.inited) return;
    root.dataset.inited = "1";

    var viewerEl = root.querySelector("[data-viewer]");
    var ownInput = root.querySelector("[data-reg-input]");
    var extSel   = root.dataset.regSelector;
    var extInput = extSel ? document.querySelector(extSel) : null;
    var FONT     = root.dataset.font || '"PlateFont","Arial Narrow",sans-serif';
    var rear     = root.dataset.plate === "rear";

    var plateColour = rear ? 0xffd400 : 0xffffff;
    var textBg      = rear ? "#ffd400" : "#ffffff";
    var textColour  = "#111111";
    var reg = (extInput && extInput.value) || (ownInput && ownInput.value) || root.dataset.defaultReg || "AJ23 PLT";

    // ---- plate legend (tweak these) ----
    var SUPPLIER  = "AJ Plates   DL1 1TF";
    var BS_NUMBER = "BSAU 145e";

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
    camera.position.set(0.4, 0.28, 3.7);

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.outputEncoding = THREE.sRGBEncoding;
    viewerEl.appendChild(renderer.domElement);

    scene.add(new THREE.AmbientLight(0xffffff, 0.7));
    var key = new THREE.DirectionalLight(0xffffff, 1.5); key.position.set(3, 4, 5); scene.add(key);
    var fill = new THREE.DirectionalLight(0xffffff, 0.45); fill.position.set(-4, 1, 2); scene.add(fill);

    function roundedRect(w, h, r) {
      var s = new THREE.Shape(), x = -w / 2, y = -h / 2;
      s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
      s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
      s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y); return s;
    }
    var bodyGeo = new THREE.ExtrudeGeometry(roundedRect(W, H, R),
      { depth: D, bevelEnabled: true, bevelThickness: 0.015, bevelSize: 0.015, bevelSegments: 2 });
    bodyGeo.center();
    var bodyMat = new THREE.MeshStandardMaterial({ color: plateColour, roughness: 0.35, metalness: 0 });
    var plate = new THREE.Mesh(bodyGeo, bodyMat); scene.add(plate);

    // ---- front (printed) face ----
    var cvs = document.createElement("canvas"); cvs.width = Math.round(W * 400); cvs.height = 400;
    var ctx = cvs.getContext("2d");
    var tex = new THREE.CanvasTexture(cvs); tex.encoding = THREE.sRGBEncoding;
    tex.minFilter = THREE.LinearFilter; tex.generateMipmaps = false; tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    var face = new THREE.Mesh(new THREE.PlaneGeometry(W * 0.985, H * 0.985),
      new THREE.MeshBasicMaterial({ map: tex, transparent: true }));
    face.position.z = D / 2 + 0.018; plate.add(face);

    // layout (px @ ~3.6 px/mm)
    var regCenterY = 185, regCapTarget = 246, regCapS = regCapTarget / 0.70;
    var maxRegW = cvs.width - 88;
    var legendBaseline = cvs.height - 14, legendSize = 22;

    function measure(S) {
      ctx.font = "700 " + S + "px " + FONT;
      var charGap = S * 0.06, groupGap = S * 0.38, items = [], total = 0;
      for (var i = 0; i < reg.length; i++) {
        var ch = reg[i].toUpperCase();
        if (ch === " ") { items.push({ sp: groupGap }); total += groupGap; }
        else { var w = ctx.measureText(ch).width; items.push({ ch: ch, w: w, g: charGap }); total += w + charGap; }
      }
      if (reg.length && reg[reg.length - 1] !== " ") total -= charGap;
      return { items: items, total: total };
    }

    function draw() {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.letterSpacing = "0px";
      ctx.fillStyle = textBg; ctx.fillRect(0, 0, cvs.width, cvs.height);

      // registration: size by height, shrink if too wide; centre on true glyph box
      ctx.fillStyle = textColour; ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
      var w100 = measure(100).total || 1;
      var S = Math.min(regCapS, maxRegW / w100 * 100);
      var L = measure(S); // also sets ctx.font to S
      var bm = ctx.measureText("ABCXYZ0");
      var asc = bm.actualBoundingBoxAscent || S * 0.70, desc = bm.actualBoundingBoxDescent || 0;
      var y = regCenterY + (asc - desc) / 2;
      var x = (cvs.width - L.total) / 2;
      for (var i = 0; i < L.items.length; i++) {
        var it = L.items[i];
        if (it.sp) { x += it.sp; }
        else { ctx.fillText(it.ch, x, y); x += it.w + it.g; }
      }

      // legend row
      ctx.fillStyle = "#111111"; ctx.textBaseline = "alphabetic"; ctx.letterSpacing = "0px";
      ctx.font = "600 " + legendSize + "px Arial, sans-serif";
      ctx.textAlign = "center"; ctx.fillText(SUPPLIER, cvs.width / 2, legendBaseline);
      ctx.textAlign = "right";  ctx.fillText(BS_NUMBER, cvs.width - 44, legendBaseline);

      tex.needsUpdate = true;
    }

    // ---- back face (faded logo / wordmark) ----
    var bcvs = document.createElement("canvas"); bcvs.width = cvs.width; bcvs.height = cvs.height;
    var bctx = bcvs.getContext("2d");
    var btex = new THREE.CanvasTexture(bcvs); btex.encoding = THREE.sRGBEncoding;
    btex.minFilter = THREE.LinearFilter; btex.generateMipmaps = false; btex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    var back = new THREE.Mesh(new THREE.PlaneGeometry(W * 0.985, H * 0.985),
      new THREE.MeshBasicMaterial({ map: btex, transparent: true }));
    back.position.z = -(D / 2 + 0.018); back.rotation.y = Math.PI; plate.add(back);

    function mirror(fn) { bctx.save(); bctx.setTransform(-1, 0, 0, 1, bcvs.width, 0); fn(); bctx.restore(); btex.needsUpdate = true; }
    function drawBackText() {
      mirror(function () {
        bctx.fillStyle = "#e3e3e3"; bctx.textAlign = "center"; bctx.textBaseline = "middle";
        bctx.letterSpacing = "8px"; bctx.font = "700 170px " + FONT;
        bctx.fillText("AJ PLATES", bcvs.width / 2, bcvs.height / 2);
      });
    }
    function drawBack() {
      bctx.setTransform(1, 0, 0, 1, 0, 0); bctx.clearRect(0, 0, bcvs.width, bcvs.height);
      if (LOGO_URL) {
        var img = new Image(); img.crossOrigin = "anonymous";
        img.onload = function () {
          mirror(function () {
            bctx.globalAlpha = 0.12;
            var s = Math.min((bcvs.width * 0.55) / img.width, (bcvs.height * 0.55) / img.height);
            var iw = img.width * s, ih = img.height * s;
            bctx.drawImage(img, (bcvs.width - iw) / 2, (bcvs.height - ih) / 2, iw, ih);
            bctx.globalAlpha = 1;
          });
        };
        img.onerror = drawBackText;
        img.src = LOGO_URL;
      } else { drawBackText(); }
    }

    var controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.dampingFactor = 0.08;
    controls.minDistance = 2; controls.maxDistance = 8; controls.enablePan = true;

    function resize() {
      var w = viewerEl.clientWidth, h = viewerEl.clientHeight || 340;
      renderer.setSize(w, h); renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      camera.aspect = w / h; camera.updateProjectionMatrix();
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(viewerEl);
    else window.addEventListener("resize", resize);
    resize();

    function onInput(e) {
      reg = e.target.value || " ";
      if (ownInput && e.target !== ownInput) ownInput.value = e.target.value;
      if (extInput && e.target !== extInput) extInput.value = e.target.value;
      draw();
    }
    if (extInput) extInput.addEventListener("input", onInput);
    if (ownInput) ownInput.addEventListener("input", onInput);

    draw(); drawBack();
    if (window.FontFace) {
      new FontFace("PlateFont", 'url("' + FONT_URL + '")', { weight: "700" })
        .load()
        .then(function (f) { document.fonts.add(f); draw(); drawBack(); })
        .catch(function (e) { console.warn("PlateFont load failed:", e); });
    } else if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { draw(); drawBack(); });
    }

    (function loop() { requestAnimationFrame(loop); controls.update(); renderer.render(scene, camera); })();
  }

  function whenThree(cb) {
    if (window.THREE && THREE.OrbitControls) return cb();
    var t = setInterval(function () { if (window.THREE && THREE.OrbitControls) { clearInterval(t); cb(); } }, 50);
  }
  function lazy(root) {
    if (!("IntersectionObserver" in window)) return whenThree(function () { initPlate(root); });
    var io = new IntersectionObserver(function (ents, o) {
      ents.forEach(function (en) { if (en.isIntersecting) { o.disconnect(); whenThree(function () { initPlate(root); }); } });
    }, { rootMargin: "200px" });
    io.observe(root);
  }
  function boot() { document.querySelectorAll(".plate-preview").forEach(lazy); }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector(".plate-preview"); if (r) { delete r.dataset.inited; lazy(r); }
  });
})();